import { Component } from '@angular/core';
import { FUIPopoverRef } from '@fry/ui-material/popover';
import { WorkflowAuditIssue } from './audit.service';

export interface WorkflowAuditIssueListComponentData {
  issues: WorkflowAuditIssue[];
}

@Component({
    selector: 'eas-workflow-audit-issue-list',
    templateUrl: './audit-issue-list.component.html',
    // styleUrls: ['./audit-issue-list.component.css'],
    styles: [`
    mat-list { margin-top: 5px; margin-right: 10px; background-color: #fff;}
  `],
    standalone: false
})
export class WorkflowAuditIssueListComponent {

  public issues: WorkflowAuditIssue[];

  constructor(private popoverRef: FUIPopoverRef<WorkflowAuditIssueListComponentData>) {
    this.issues = this.popoverRef.data?.issues ?? [];
  }
}
